import { isEmpty, get } from 'lodash';
import { connect } from 'react-redux';

import CollectionChild from 'components/CollectionChild';
import Catalog from 'state/selectors/catalog';

const mapStateToProps = (
  state,
  { handle, initialColorwayHandle, hasMobileQuickAddRow, isLoading, ...otherOwnProps }
) => {
  const masterProduct = Catalog.getMasterProduct(state, handle);

  if (!masterProduct && !isLoading) {
    throw new Error(`Could not find master product with handle "${handle}"`);
  }

  const availableColorways = Catalog.getAvailableMasterProductColorways(state, handle);

  return {
    name: get(masterProduct, 'name'),
    handle,
    hasMobileQuickAddRow,
    initialColorwayHandle,
    isEmpty: isEmpty(availableColorways),
    tagLine: get(masterProduct, 'tagLine'),
    isLoading,
    ...otherOwnProps,
  };
};

export default connect(mapStateToProps)(CollectionChild);
